import React from "react";
import { HeroSection } from "./fitness-tracker-components/HeroSection.jsx";
import { OverviewSection } from "./fitness-tracker-components/OverviewSection.jsx";
import { SolutionSection } from "./fitness-tracker-components/SolutionSection.jsx";
import { ProblemStatement } from "./fitness-tracker-components/ProblemStatement.jsx";
import { CompetitiveAnalysis } from "./fitness-tracker-components/CompetitiveAnalysis.jsx";
import { FeaturesSection } from "./fitness-tracker-components/FeaturesSection.jsx";
import { UserPersonas } from "./fitness-tracker-components/UserPersonas.jsx";
import { EmpathyMap } from "./fitness-tracker-components/EmpathyMap.jsx";
import { HiFiDesigns } from "./fitness-tracker-components/HiFiDesigns.jsx";
import { OutcomeSection } from "./fitness-tracker-components/OutcomeSection.jsx";
import "./index.css";

function FitnessTrackerPage() {
  return (
    <div className="bg-[#0d0d0d] min-h-screen w-full overflow-x-hidden text-white">
      <HeroSection />
      <OverviewSection />
      <ProblemStatement />
      <CompetitiveAnalysis />
      <UserPersonas />
      <EmpathyMap />
      <FeaturesSection />
      <SolutionSection />
      <HiFiDesigns />
      <OutcomeSection />
    </div>
  );
}

export default FitnessTrackerPage;
